<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter">
<p class="center"><img alt="" src="OEBPS/images/5-1.jpg"/></p>
<p class="caption">AN UNNAMED FUNGOID GROWTH FOUND UPON A TREE IN THE NEIGHBOURHOOD OF THE KLONDYKE.</p>
<p class="caption"><em>From a photograph</em>.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// fm.vue?44a785df